
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../layout"
import { loadContacts } from "../../redux/modules/contacts"
import Map from "./map"
import Managers from "./managers"

const Contacts = () => {    
    const dispatch = useDispatch();
    const auth = useSelector(state => state.auth);
    const contacts = useSelector(state => state.contacts);
    const managers = useSelector(state => state.meeting.managers);
    const mobile = useSelector(state => state.mobile);

    useEffect(() => {
        document.title = 'Контакты | Личный кабинет Брокера THE FIVE';
        if(!contacts.loaded) {
            dispatch(
                loadContacts({
                    cmd: 'contacts',
                    _debug_token: auth.token
                }))
        }
    }, [])

    console.log(contacts)
    
    return (
        <Layout>
            {contacts.response && (<div className="contacts">
                <div className="contacts__list">
                    <div className="title">Офис продаж</div>

                    {contacts.response.address && (
                        <>
                            <div className="contacts__label">Адрес</div>
                            <div className="contacts__text">
                                {contacts.response.address}
                                {mobile && <a href={`https://maps.yandex.ru/?text=${contacts.response.coords[0]},${contacts.response.coords[1]}`} target="_blank" class="contacts__map">на карте</a>}
                            </div>
                        </>
                    )}   

                    {contacts.response.phone && (
                        <>
                            <div className="contacts__label">Телефон</div>
                            <div className="contacts__text"><a href={`tel:${contacts.response.phone}`} class="contacts__phone">{contacts.response.phone}</a></div>
                        </>
                    )}   

                    {contacts.response.email && (
                        <>
                            <div className="contacts__label">Электронная почта</div>
                            <div className="contacts__text"><a href={`mailto:${contacts.response.email}`} class="contacts__mail">{contacts.response.email}</a></div>
                        </>
                    )}   

                    {contacts.response.telegram && (
                        <>
                            <div className="contacts__label">Телеграм для партнёров</div>
                            <div className="contacts__text"><a href={contacts.response.telegram.link} target="_blank" class="contacts__telegram">{contacts.response.telegram.name}</a></div>
                        </>
                    )}                    

                </div>
                {!mobile && (<div className="contacts__map">
                    <Map coords={contacts.response.coords} address={contacts.response.address} />
                </div>)}
            </div>)}
            {contacts.response && (
                <>
                    <div className="managers-title">Менеджеры</div>
                    <Managers data={managers} photo={true}/>
                </>
            )}
        </Layout>
    )
}

export default Contacts